export default {
  methods: {
    buildQuery() {
      var query = {}
      query.billingPeriod = this.$store.state.shared.billingPeriod
      query.billingStatus = this.$store.state.shared.billingStatus
      query.projectId = this.$store.state.shared.projectId
      query.siteId = this.$store.state.shared.siteId
      query.userId = this.$store.state.shared.selectedUserId
      query.showClosed = this.$store.state.shared.showClosed
      query.filterBy = this.$store.state.trips.filterBy
      query.filterCol = this.$store.state.trips.filterCol
      query.filterBy2 = this.$store.state.trips.filterBy2
      query.filterCol2 = this.$store.state.trips.filterCol2
      query.dateRangeStart = this.$store.state.shared.dateRangeStart
      query.dateRangeEnd = this.$store.state.shared.dateRangeEnd
      return query
    }
  }
}
